module.exports = __webpack_public_path__ + "img/rank2.ffa6566a.png";